import { getCoverThumbUrl } from '../../utils/coverUrl';
import React from 'react';
import { DragScrollCarousel } from './SeriesContinuation';

const getCoverUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api')) return `${window.location.origin}${url}`;
  return url;
};

const RecommendationsRow = ({ similarBooks, currentTitle, navigate }) => {
  if (!similarBooks?.recommendations?.length) return null;
  return (
    <div className="bg-gradient-to-b from-black/70 to-black/75 backdrop-blur-sm py-12" data-testid="recommendations-section">
      <div className="max-w-screen-2xl mx-auto px-8">
        <h2 className="text-2xl font-bold text-white mb-2">
          Because you're reading "{currentTitle}"...
        </h2>
        <p className="text-gray-400 mb-6 text-sm">You might also enjoy these similar titles</p>
        <DragScrollCarousel>
          {similarBooks.recommendations.map((rec) => (
            <div
              key={rec.id}
              className="flex-shrink-0 w-48 group select-none transition-transform duration-200 hover:scale-105"
              data-testid={`recommendation-${rec.id}`}
            >
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={getCoverThumbUrl(rec.cover_image_url)}
                  alt={rec.title}
                  className="w-48 h-72 object-cover rounded-lg pointer-events-none"
                  loading="lazy"
                  draggable="false"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-colors rounded-lg flex items-center justify-center">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/book/${rec.id}`);
                    }}
                    className="bg-white text-black text-xs font-bold px-4 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-gray-200"
                    data-testid={`rec-view-${rec.id}`}
                  >
                    View Book
                  </button>
                </div>
                {rec.matching_genres?.length > 0 && (
                  <div className="absolute bottom-2 left-2 right-2 flex flex-wrap gap-1">
                    {rec.matching_genres.slice(0, 2).map((genre) => (
                      <span
                        key={`genre-${genre}`}
                        className="bg-red-600/80 text-white text-[10px] px-2 py-0.5 rounded-full backdrop-blur-sm"
                      >
                        {genre}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <p className="text-white text-sm font-medium mt-2 line-clamp-2">{rec.title}</p>
              <p className="text-gray-400 text-xs mt-1">{rec.author}</p>
              {rec.rating > 0 && (
                <p className="text-yellow-400 text-xs mt-1">
                  <span className="mr-1">&#9733;</span>
                  {rec.rating?.toFixed(1)}
                </p>
              )}
            </div>
          ))}
        </DragScrollCarousel>
      </div>
    </div>
  );
};

export default RecommendationsRow;
